import { useState, useEffect } from 'react';

/**
 * Returns false during SSR/pre-render and initial hydration,
 * then true after the component has mounted on the client.
 * Use this to skip framer-motion initial animations during hydration
 * to prevent React Error #418 (hydration mismatch).
 */
export const useHydrated = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
};
